import { render, staticRenderFns } from "./DefaultTab.vue?vue&type=template&id=3874ea7b&"
import script from "./DefaultTab.vue?vue&type=script&lang=js&"
export * from "./DefaultTab.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTab.vue?vue&type=style&index=0&id=3874ea7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports